import React from "react";

function MediaUnavailable({icon: Icon,title,description}) {
  return (
    <div className="flex w-[250px] max-w-full items-center gap-3 rounded-[9px] bg-[#f0f2f5] px-3 py-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[8px] bg-[#e2e6e8] text-[#667781]">
        <Icon size={19} strokeWidth={1.8} />
      </div>

      <div className="min-w-0">
        <p className="text-[12px] font-medium text-[#3b4a54]">
          {title}
        </p>

        <p className="mt-0.5 text-[10px] text-[#8696a0]">
          {description}
        </p>
      </div>
    </div>
  );
}

export default MediaUnavailable;